import React from "react"
import { Box, Text } from "@chakra-ui/react"
import Button from "components/Buttons/Button"
import UrlField from "components/ReactHookForm/UrlField"
import { Control, useController } from "react-hook-form"
import { DioboxEvent } from "sharedTypes"

type Props = {
  control: Control<any>
  event: DioboxEvent
  mapEnabled: boolean
}

const UrlWithRegenerateLink = ({ control, event, mapEnabled }: Props) => {
  const PORTAL_MAP_URL_KEY = "portalMapUrl"
  const { field } = useController({ name: PORTAL_MAP_URL_KEY, control })

  const handleClick = () => {
    const {
      venue, addressLine1, addressLine2, city, state, zipcode, country,
    } = event
    const addressString = [venue, addressLine1, addressLine2, city, state, zipcode, country].filter((c) => c).join(" ").replace(/ /g, "+")
    const url = `https://maps.google.com/?q=${addressString}`
    field.onChange(url)
  }

  return (
    <>
      <UrlField name={PORTAL_MAP_URL_KEY} control={control} disabled={!mapEnabled} />
      <Box mt={2} mb={5}>
        <Text color="gray.500" fontSize="sm">
          This link is automatically generated from your event address and opens
          in Google Maps. You can regenerate it anytime if your location changes.
        </Text>
      </Box>
      <Button isDisabled={!mapEnabled} variant="outline" onClick={handleClick}>Regenerate Link</Button>
    </>
  )
}

export default UrlWithRegenerateLink
